// Step 6: Images - Carousel and gallery images
// Always optional; uses the existing ImageSelector component

import React from 'react';
import { Tour } from '../../../types/tours';
import ImageSelector from '../ImageSelector';

interface StepImagesProps {
  formData: Partial<Tour>;
  onImagesChange: (field: 'carousel_images' | 'gallery_images', urls: string[]) => void;
}

const StepImages: React.FC<StepImagesProps> = ({ formData, onImagesChange }) => {
  return (
    <div className="bg-[#1F2B1F] rounded-xl p-6 border border-white/10">
      <div className="space-y-10">
        <div>
          <h3 className="text-lg font-semibold text-white mb-2">Carousel Images</h3>
          <p className="text-sm text-white/40 mb-4">Add up to 3 images for the tour card carousel.</p>
          <ImageSelector
            images={formData.carousel_images || []}
            onChange={(urls) => onImagesChange('carousel_images', urls)}
            maxImages={3}
            type="carousel"
          />
        </div>

        <div className="border-t border-white/10 pt-10">
          <h3 className="text-lg font-semibold text-white mb-2">Gallery Images</h3>
          <p className="text-sm text-white/40 mb-4">Add up to 15 images for the tour detail gallery.</p>
          <ImageSelector
            images={formData.gallery_images || []}
            onChange={(urls) => onImagesChange('gallery_images', urls)}
            maxImages={15}
            type="gallery"
          />
        </div>
      </div>
    </div>
  );
};

export default StepImages;
